module.exports = __webpack_public_path__ + "img/logo-cambiositalo.08e17101.png";